import React, { MouseEventHandler } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import { Checkbox } from '@ui/components/Checkbox/checkbox';
import { checkboxClickHandler } from '@ui/components/Checkbox/checkbox-click-handler';

interface IProps {
    name: string;
    imei: string;
    selected: boolean;
    onDeviceClick: MouseEventHandler<HTMLElement>;
    onDeviceSelect: checkboxClickHandler;
}

const Component: React.FC<IProps> = ({
    name,
    imei,
    selected,
    onDeviceClick,
    onDeviceSelect,
}: IProps) => {
    return (
        <Tooltip
            classes={{
                popper: 'groups__item-menu-tooltip-popper',
                tooltip: 'groups__item-menu-tooltip',
            }}
            title={`IMEI: ${imei}`}
            placement="top"
            followCursor
        >
            <ListItemButton
                className="device__item"
                component="li"
                selected={selected}
                id={imei}
                onClick={onDeviceClick}
            >
                <Checkbox
                    name={name}
                    value={imei}
                    status={selected ? 'checked' : 'unchecked'}
                    onClick={onDeviceSelect}
                />
                <ListItemText
                    classes={{
                        root: 'device__text-item',
                        primary: 'device__text',
                    }}
                    primary={name}
                />
            </ListItemButton>
        </Tooltip>
    );
};

const DeviceItemComponent = React.memo(Component);

export default DeviceItemComponent;
